import React from 'react';
import { Box, Typography, Button, Container, Stack, useTheme } from '@mui/material';
import HolidayIcon from '@mui/icons-material/Celebration';
import DiscountIcon from '@mui/icons-material/LocalOffer';

interface HolidayPromotion {
  id: string;
  name: string;
  discount: number;
  endDate: string;
}

const PromotionBanner: React.FC = () => {
  // Mock active promotion - in real app, fetch from Supabase
  const activePromotion: HolidayPromotion | null = {
    id: '1',
    name: 'Harvest Festival',
    discount: 20,
    endDate: '2026-03-15',
  };

  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  if (!activePromotion) return null;

  return (
    <Box 
      sx={{ 
        background: isDark
          ? 'linear-gradient(90deg, #1B5E20 0%, #388E3C 60%, #66BB6A 100%)'
          : 'linear-gradient(90deg, #2e7d32 0%, #4caf50 100%)',
        color: 'white',
        py: 1.5,
        position: 'relative',
        overflow: 'hidden',
        boxShadow: 2
      }}
    >
      <Container maxWidth="xl">
        <Stack 
          direction={{ xs: 'column', sm: 'row' }} 
          spacing={2} 
          alignItems="center" 
          justifyContent="center"
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <HolidayIcon sx={{ color: isDark ? '#FFE082' : '#ffeb3b' }} />
            <Typography variant="body1" fontWeight="bold">
              {activePromotion.name} Special!
            </Typography>
          </Box>
          
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <DiscountIcon />
            <Typography variant="body2">
              Get up to <Box component="span" sx={{ fontWeight: 'bold', fontSize: '1.1rem', color: isDark ? '#FFE082' : '#ffeb3b' }}>{activePromotion.discount}% OFF</Box> on participating shops.
            </Typography>
          </Box>

          <Button 
            variant="contained" 
            size="small"
            sx={{ 
              bgcolor: isDark ? '#0E0F10' : 'white', 
              color: isDark ? '#F4F6F8' : 'primary.main',
              fontWeight: 'bold',
              '&:hover': { bgcolor: isDark ? '#17191B' : '#f5f5f5' },
              borderRadius: '20px',
              px: 3
            }}
          >
            Shop Now
          </Button>
          
          <Typography variant="caption" sx={{ opacity: 0.9 }}>
            Ends {new Date(activePromotion.endDate).toLocaleDateString()}
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
};

export default PromotionBanner;
